export default __webpack_public_path__ + "static/media/cal_bg10.d0f16c40.jpg";